import { Button, Paper, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { FormProvider, TextField } from '../../components';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { request, toast } from '../../utils';
import { setUser } from '../../store/reducers/user';
import { useDispatch } from 'react-redux';
import { BASE_URL } from '../../utils';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

export const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRolesData = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/activation`);
        if (response.status === 200) {
          console.log(response.data.message);
        } else {
          alert(response.data.message);
          navigate('/activation');
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    };

    fetchRolesData();
  }, []);

  const methods = useForm({
    defaultValues: {
      email: '',
      password: ''
    },
    mode: 'all'
  });

  const { handleSubmit } = methods;

  const onFormSubmitHandler = async (formValue) => {
    setLoading(true);

    try {
      const response = await request('/login', { method: 'POST', body: formValue });

      if (response?.success) {
        const userToken = response.user?.token;
        const appToken = response?.token;

        // Verify both tokens exist
        if (userToken && appToken) {
          // Save the user details and tokens in localStorage
          localStorage.setItem('user', JSON.stringify(response.user));
          localStorage.setItem('token', appToken);

          // Verify both tokens using jwt-decode
          const isValidUserToken = verifyToken(userToken);
          const isValidAppToken = verifyToken(appToken);

          // If both tokens are valid, allow navigation
          if (isValidUserToken && isValidAppToken) {
            dispatch(setUser(response?.user));
            toast('Successfully logged in user', { variant: 'success' });
            navigate(`/${response.user.redirect}`);
          } else {
            // If tokens are not valid, show an error message
            toast('Your Subscription Has Been Expire Please Contact Your Admin', { variant: 'error' });
          }
        } else {
          // Show error if tokens are missing
          toast('Your Subscription Has Been Expire Please Contact Your Admin', { variant: 'error' });
        }
      } else {
        // Show response message if login failed
        toast(response.message || 'Something went wrong', { variant: 'warning' });
      }
    } catch (error) {
      console.error('Login error:', error);
      toast('Something went wrong', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // Token verification using jwt-decode
  const verifyToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      const expiryTime = decoded.exp * 1000; // Convert expiry time to milliseconds
      const isTokenValid = Date.now() < expiryTime;

      return isTokenValid;
    } catch (error) {
      console.error('Token verification error:', error);
      return false;
    }
  };

  return (
    <Paper
      sx={{
        width: 'clamp(30rem, 50%, 40rem)',
        mx: 'auto',
        my: 7,
        p: 3,
        backgroundColor: 'transparent',
        backdropFilter: 'blur(5rem)',
        borderRadius: '1.5rem',
        height: '30rem'
      }}
    >
      <Typography variant="h3" gutterBottom color="common.white" textAlign="center" fontWeight={700}>
        Login
      </Typography>
      <FormProvider
        sx={{ width: 'clamp(25rem, 80%, 35rem)', mx: 'auto', mt: 5 }}
        methods={methods}
        onSubmit={handleSubmit(onFormSubmitHandler)}
      >
        <Stack spacing={2}>
          <TextField name="email" placeholder="email" />
          <TextField name="password" placeholder="Password" type="password" />
        </Stack>
        <Button
          disabled={loading}
          fullWidth
          sx={{ mt: 3, fontWeight: 700 }}
          variant="contained"
          color="primary"
          type="submit"
        >
          submit
        </Button>
      </FormProvider>
    </Paper>
  );
};
